import React from "react";
import { Icon } from "semantic-ui-react";

/** React components for scrolling back to the top of the page **/
  
class ScrollButton extends React.Component {
constructor() {
    super();
    this.state = {
        intervalId: 0
    };
}

scrollStep() {
    if (window.pageYOffset === 0) {
        clearInterval(this.state.intervalId);
    }
    window.scroll(0, window.pageYOffset - this.props.scrollStepInPx);
}

scrollToTop() {
    let intervalId = setInterval(this.scrollStep.bind(this), this.props.delayInMs);
    this.setState({ intervalId: intervalId });
}

render () {
    return <Icon
            name="arrow alternate circle up outline"
            title='Back to top' 
            className='pageScrollToTop' 
            onClick={() => {
                this.scrollToTop();
            }}
            size="big"
        />
    }
} 

class ScrollApp extends React.Component {
    render () {
        return (
            <div className="pageScrollLong">
                <ScrollButton scrollStepInPx="50" delayInMs="16.66"/>
            </div>
        );
    }
}

export default ScrollApp;